import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { CheckboxOption } from './CheckboxOption';
/**
 * Inline checkbox option. For backwards compatibility only, use
 * CheckboxOption directly instead.
 *
 * @deprecated
 */

export var CheckboxInline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(CheckboxOption, _extends({
    ref: ref
  }, props, {
    inline: true
  }));
});
CheckboxInline.displayName = 'CheckboxInline';